import { useAppContext } from '../../context/AppContext';
import { connectQuickbooks, connectXero } from '../../services';
import qbo from '../../assets/images/qbo.png';
import xero from '../../assets/images/xero.png';

const ACCT_OPTIONS = [
  { id: 'qbo', label: 'QuickBooks', img: qbo, connect: connectQuickbooks },
  { id: 'xero', label: 'Xero', img: xero, connect: connectXero },
];

export const AccountingConnect = () => {
  const { base_url, token } = useAppContext();

  const handleConnect = async (connectFn) => {
    const redirectUrl = await connectFn(base_url, token);
    window.location.href = redirectUrl;
  };

  return (
    <div>
      <div className="step-header">
        <h2>Connect Your Accounting Software</h2>
        <p>
          Connecting to your accounting software allows Slipstream to create invoices, customers, and products when deals are closed.
          Information about the full scope of access requested will be displayed when you select your platform below.
        </p>
      </div>

      <div className="connect-cards">
        {ACCT_OPTIONS.map((acct) => (
          <div key={acct.id} className="connect-card">
            <div className="connect-card-info">
              <div className={`connect-card-icon ${acct.id === 'qbo' ? 'quickbooks' : ''}`}>
                <img src={acct.img} alt="" width={44} height={44} />
              </div>
              <div className="connect-card-text">
                <strong>{acct.label}</strong>
                <span>Accounting — customers &amp; invoices</span>
              </div>
            </div>
            <button
              type="button"
              className="connect-btn"
              onClick={() => handleConnect(acct.connect)}
            >
              Connect
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
